import React from 'react'
import { ThemeProvider, Typography, CssBaseline, Paper} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2';
import {theme} from '../theme.js'
import { TopBar } from '../components/TopBar/TopBar'
import {Footer} from '../components/Footer/Footer'
import tiling from '../images/blue-tile.png'
import birthdays from '../images/birthdays.jpg'
import team_building from '../images/team_building.jpg'
import special_events from '../images/special_events.jpg'
import { MiniCarousel } from '../components/Carousel/MiniCarousel.js'
export const Events = () => {
  return (
    
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <Grid container style={{backgroundImage:`url(${tiling})`, backgroundAttachment:"fixed"}}>
        <Grid item xs={12}>
          <TopBar/>
        </Grid>
        <Grid item xs={12} textAlign="center" pb={5}>
          <Typography color="white" variant="h3">
            Perfect for any occasion!
          </Typography>
        </Grid>
        <Grid item xs={12} md = {4} p ={1} position="relative">
          <Paper style={{position:"absolute", left:"50%", transform: "translate(-50%, 0%)", whiteSpace: "nowrap"}}>
            <Typography color="black" variant = "h5" >
                Birthdays
            </Typography>
          </Paper>
          <img src={birthdays} alt = "birthdays" style={{maxWidth:"100%", height:"100%"}}/>
        </Grid>
        <Grid item xs={12} md = {4} p ={1} position="relative">
        <Paper style={{position:"absolute", left:"50%", transform: "translate(-50%, 0%)", whiteSpace: "nowrap"}}>
            <Typography color="black" variant = "h5" >
                Team Building
            </Typography>
          </Paper>
          <img src={team_building} alt = "team_building" style={{maxWidth:"100%", height:"100%"}}/>
        </Grid>
        <Grid item xs={12} md = {4} p ={1} position="relative">
        <Paper style={{position:"absolute", left:"50%", transform: "translate(-50%, 0%)", whiteSpace: "nowrap"}}>
            <Typography color="black" variant = "h5" >
                Special Events
            </Typography>
          </Paper>
          <img src={special_events} alt = "team_building" style={{maxWidth:"100%", height:"100%"}}/>
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={6} p={1}  justifyContent="center">
          <MiniCarousel/>
        </Grid>
      <Footer/>
      </Grid>
    </ThemeProvider>
    )
}
